const UserDetail = ({ setFormData = [], closeUserDetail = () => { } }) => {

  return (
    <div>
      <div>
        <strong>Name :</strong> {setFormData?.chiefName}
      </div>
      <div>
        <strong>Username :</strong> {setFormData?.chiefNo + ' ' + setFormData?.email}
      </div>
      <div>
        <strong>Role :</strong> {setFormData?.groupNo + ' - ' + setFormData?.chiefNo}
      </div>
      <div>
        <strong>Comp Code :</strong> {setFormData?.companyCode}
      </div>
    </div>
  );
};

export default UserDetail;
